import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface ProductLocalParamsState {
    cardView: boolean;
    lastSeenUpdateDate: string | null;
}

const initialState: ProductLocalParamsState = {
    cardView: true,
    lastSeenUpdateDate: null
}


export const productLocalParamsSlice = createSlice({
    name: 'productLocalParams',
    initialState,
    reducers: {
        setCardView: (state, action: PayloadAction<boolean>) => {
            state.cardView = action.payload;
        },
        setLastSeenUpdateDate: (state, action: PayloadAction<string>) => {
            state.lastSeenUpdateDate = action.payload;
        }

    }
})

export const {setCardView, setLastSeenUpdateDate} = productLocalParamsSlice.actions
const productLocalParamsReducer = productLocalParamsSlice.reducer
export default productLocalParamsReducer

